<template>
  <div>
    <div class="dns">
      <div class="is-size-2">
        DNS Instructions
        <!-- {{ $t('domains.title') }} -->
      </div>
      <div class="is-size-5">
        If you would like to transfer your domain name from your current host, please update the DNS with your provider with the details below.
        <!-- {{ $t('domains.title') }} -->
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DnsInstructions'
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.dns {
  color: #363636;
}
</style>
